import groq from "groq";

export const singleRecommendationQuery = groq`*[
  _type == "recommendation" &&
  _id == $id
][0]`;
